export const DEFAULT_PROMO = 'CSMARKET';

export const PROMO_BACKGROUNDS = {
  success: 'linear-gradient(95.41deg, #24522B 2.84%, #24522B 95.34%)',
  error: 'linear-gradient(95.41deg, #4A1E21 2.84%, #292B3A 95.34%)',
  default: 'linear-gradient(95.41deg, #24522B 2.84%, #292B3A 95.34%)',
};
